// NATIVE
import React from 'react';

// INSTALLED
import { Link } from 'react-router-dom';
import { paddingCardsTables } from '../../commons';
import { Security, Settings } from '@mui/icons-material';
import { Box, Button, Card, Icon, Tabs } from '@mui/material';
import CustomButtonTab from '../../components/CustomButtonTab';
import { GeneracionTurnos } from '../../components/turnosEmpleados';
import { BreadCrumbsAndTitle } from '../../components/generics/BreadCrumbsAndTitle';

// CUSTOM

export const TurnosEmpleados = () => {
  // USE STATE
  const [value, setValue] = React.useState(0);

  // CONST FUNCTIONS
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
  }

  //  FUNCTION COMPONENT
  function CustomTabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
      </div>
    );
  }

  function a11yProps(index: number) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }

  return (
    <>
      <BreadCrumbsAndTitle
        title="Turnos Empleados"
        mainModule="Talento Humano"
        parent="Turnos Empleados"
        action=""
      />

      <div style={{ display: 'flex', justifyContent: 'end' }}>
        <Button
          component={Link}
          to={'/talento-humano/crear-empleado'}
          variant="contained"
          sx={{ marginBottom: 3 }}
          startIcon={<Settings />}
        >
          Generar Configuracion Turnos Empelados
        </Button>
      </div>

      <Box sx={{ width: '100%', marginTop: paddingCardsTables }}>
        {/* <Box sx={{ borderBottom: 1, borderColor: 'divider' }}> */}
        <Box>
          <Tabs
            variant="scrollable"
            scrollButtons="auto"
            allowScrollButtonsMobile
            TabIndicatorProps={{
              style: { display: 'none' },
            }}
            TabScrollButtonProps={{
              sx: {
                width: 40, // Cambia el ancho del botón
                height: 40, // Cambia el alto del botón
                '& svg': { fontSize: 30 }, // Ajusta el tamaño del ícono dentro del botón
              },
            }}
            selectionFollowsFocus={true}
            value={value}
            onChange={handleChange}
            aria-label="tabs detalle clientes"
          >
            {/* <CustomButtonTab icon={ <Security />} iconPosition="start" onChange={handleChange} label="Permisos" {...a11yProps(0)} /> */}
            <CustomButtonTab
              icon={<Security />}
              iconPosition="start"
              onChange={handleChange}
              label="Generacion Turnos"
              {...a11yProps(0)}
            />
            <CustomButtonTab
              icon={<Security />}
              iconPosition="start"
              onChange={handleChange}
              label="Detalle Lista Empleados"
              {...a11yProps(1)}
            />
          </Tabs>
        </Box>
      </Box>

      <Card
        sx={{
          alignItems: 'center',
          p: 3,
          borderRadius: 2,
          boxShadow: 3,
          bgcolor: 'background.paper',
        }}
      >
        <CustomTabPanel value={value} index={0}>
          <GeneracionTurnos />
        </CustomTabPanel>
        <CustomTabPanel value={value} index={1}>
          Lista Empleados
          {/* <DetalleEducacion/> */}
        </CustomTabPanel>
      </Card>
    </>
  );
};
